import { CaptureClicksRichText, JumplinksContainer } from '@/features/shared';
import { MuiGrid, MuiIconButton } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import { resolveSocialIcon } from '@/utils/resolvers';
import clsx from 'clsx';
import React from 'react';
import { DetailPageHeader } from '../../shared/DetailPageHeader';
import { TaxonomySummaryBlock } from '../../shared/TaxonomySummaryBlock';
import { TechPartnerDetailIntroProps } from './IntroContent.interface';
import useStyles from './IntroContent.styles';

const IntroContent = ({
  headline,
  includeBreadcrumb,
  addJumplinks,
  labels,
  logo,
  partnerWebsiteUrl,
  shortDescription,
  socialChannels = [],
  summary,
  theme = Theme.light,
}: TechPartnerDetailIntroProps) => {
  const classes = useStyles({});
  const headerProps = {
    headline,
    logo,
    shortDescription,
    theme,
    includeBreadcrumb,
  };

  const summaryBlockProps = {
    labels,
    summary,
    theme,
  };

  const rootClasses = clsx(classes.root);

  return (
    <>
      <MuiGrid container className={rootClasses}>
        <MuiGrid className={classes.partnerIntro} item xs={12} md={8}>
          <DetailPageHeader {...headerProps} />

          <CaptureClicksRichText className={classes.partnerSite} content={partnerWebsiteUrl} />

          {socialChannels.map((channel) => {
            const SocialIcon = resolveSocialIcon(channel.socialChannel);
            if (!SocialIcon) {
              return undefined;
            }
            return (
              <MuiIconButton
                className={classes.socialIconButton}
                key={channel.socialChannel}
                href={channel.url || ''}
                target="_blank"
              >
                <SocialIcon className={classes.socialIcon} />
              </MuiIconButton>
            );
          })}
        </MuiGrid>
        {addJumplinks && (
          <MuiGrid item xs={12} md={4}>
            <JumplinksContainer
              theme={theme}
              title={labels?.jump_to || 'Jump to'}
              className={classes.jumplinks}
            />
          </MuiGrid>
        )}
        {summary && summary.taxonomy && <TaxonomySummaryBlock {...summaryBlockProps} />}
      </MuiGrid>
    </>
  );
};

export default IntroContent;
